type FlairPlusProps = {
  className?: string;
  width: number;
  height: number;
  ariaLabel: string;
};

const FlairPlus = ({ className, width, height, ariaLabel }: FlairPlusProps) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 12 12"
    role="img"
    aria-label={ariaLabel}
  >
    <path
      fill="#4b7ecf"
      stroke="white"
      strokeWidth="1.5"
      paintOrder="stroke"
      filter="drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.3))"
      d="M8.08 3.92C6.91 2.746 6.993 0 6 0s-.91 2.747-2.08 3.92C2.746 5.09 0 5.007 0 6s2.747.91 3.92 2.08C5.09 9.254 5.01 12 6 12s.91-2.747 2.08-3.92C9.254 6.91 12 6.99 12 6s-2.747-.909-3.92-2.08"
    />
  </svg>
);

export default FlairPlus;
